export class User {
    id?: string;
    name?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    Username?: string;
    authenticated: boolean = false;
    img?: string;
    company_name?: string;
    company_legal_name?: string;
    company_tax_id?: string;
    identity?: any;
    connection?: string;
    tenant_id?:string;

    constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./src/app/views/authentication/authentication.model.ts